<template>
  <section class="flex flex-col gap-y-4">
    <router-link :to="{name: 'ServicesGroup'}" v-if="hasDuplicatedServices && $can('services.procedure.execute')">
      <card bg="bg-slate-500" padding="p-4" class="text-gray-50 text-sm hover:underline duration-200">
        <i class="fa-solid fa-layer-group"></i>
        Existem serviços que podem estar duplicados. Clique para visualizar
      </card>
    </router-link>

    <ServiceList
        title="Solicitações"
        :data="services"
        :loading="loading"
        :pagination="pagination"
        :searchForm="searchForm"
        @change-page="getServices"
        scope="inbox"
        :organizations="availableOrganizationsForFilter ?? organizations"
    ></ServiceList>
  </section>

</template>


<script>

import ServiceList from "#views/service/components/ServiceList.vue";
import organizationsRepository from "#repositories/organizationsRepository";
import serviceRepository from "#repositories/serviceRepository";
import {request} from "#repositories/repository";

export default {
  name: "ServicesInbox",
  components: {
    ServiceList
  },
  data() {
    return {
      hasDuplicatedServices: false,
      searchTimer: null,
      loading: true,
      services: [],
      organizations: [],
      availableOrganizationsForFilter: null,
      searchForm: {
        term: this.$route.query.term,
        source_service_priority_id: this.validateQuery(this.$route.query.source_service_priority_id),
        service_status_id: this.validateQuery(this.$route.query.service_status_id),
        started_at: this.$route.query.started_at,
        finished_at: this.$route.query.finished_at,
        organization_id: this.validateQuery(this.$route.query.organization_id),
        neighborhood_id: this.validateQuery(this.$route.query.neighborhood_id),
        source_procedure: this.validateQuery(this.$route.query.source_procedure),
        source_service: this.validateQuery(this.$route.query.source_service),
      },
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
    }
  },
  methods: {
    validateQuery(query) {
      const int = parseInt(query);
      return int ? int : query;
    },
    async getOrganizations() {
      this.organizations = (await organizationsRepository.getOrganizations()).data;
    },
    async getServices(page = 0) {
      if (page !== 0) this.pagination.page = page;

      this.loading = true;

      this.$router.push({
        path: this.$route.path,
        query: {
          page: this.pagination.page,
          term: this.searchForm.term,
          source_service_priority_id: this.searchForm.source_service_priority_id,
          service_status_id: this.searchForm.service_status_id,
          started_at: this.searchForm.started_at,
          finished_at: this.searchForm.finished_at,
          organization_id: this.searchForm.organization_id,
          neighborhood_id: this.searchForm.neighborhood_id,
          source_procedure: this.searchForm.source_procedure,
          source_service: this.searchForm.source_service,
        }
      });

      let response = await serviceRepository.getServicesInbox({
        term: this.searchForm.term,
        source_service_priority_id: this.searchForm.source_service_priority_id,
        service_status_id: this.searchForm.service_status_id,
        started_at: this.searchForm.started_at,
        finished_at: this.searchForm.finished_at,
        organization_id: this.searchForm.organization_id,
        neighborhood_id: this.searchForm.neighborhood_id,
        source_procedure: this.searchForm.source_procedure,
        source_service: this.searchForm.source_service,
        ...this.pagination
      })

      this.availableOrganizationsForFilter = response.organizations_filter_values;
      this.services = request.pagination(
          response,
          this.pagination
      );

      this.loading = false;
    },
    searchService() {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getServices();
      }, 750);
    },
  },
  watch: {
    services(newer) {
      newer.forEach(service => {
        let organizations_procedure = [];
        service.organizations.forEach(organization_service => {
          organizations_procedure.push(
              this.organizations.find(organization => organization.id === organization_service.organization_id).name
          );
        });
        service.organization = organizations_procedure;
      });
    },
  },
  created() {
    ['searchForm.source_service_priority_id', 'searchForm.term', 'searchForm.service_status_id', 'searchForm.started_at','searchForm.finished_at', 'searchForm.organization_id', 'searchForm.neighborhood_id', "searchForm.finished_at", 'searchForm.source_procedure','searchForm.source_service'].forEach(search => {
      this.$watch(search, this.searchService);
    });
  },
  async mounted() {
    serviceRepository.fetchDuplicatedServices().then((response) => {
      this.hasDuplicatedServices = response.data.length > 0;
    });
    await this.getOrganizations();
    await this.getServices();
  },
};
</script>
